import { render } from "./BusinessInvoice.vue?vue&type=template&id=73bcbf2e"
import script from "./BusinessInvoice.vue?vue&type=script&lang=js"
export * from "./BusinessInvoice.vue?vue&type=script&lang=js"

import "./BusinessInvoice.vue?vue&type=style&index=0&id=73bcbf2e&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__